const TYPE_CONNECTION_LS = { nameLsApp: 'lsApp', nameLsAlarms: 'lsAlarms' }

export const ID_ZENDESK_QA = 'da6c5fc6-5835-457b-b0f9-b57185ed5abb'
export const ID_ZENDESK = '1d90822b-7d62-4a50-a427-90c4be13ce35'
export const ID_ZENDESK_RETO_ACTINVEER = 'e1f7ae88-88d7-4a5e-943f-39cbf05c380d'

export default TYPE_CONNECTION_LS
